import React, { useState, useEffect } from "react";
import { ProfileView } from "./profile-view";
import serviceProvider from '../../services/axios'
import "./profile.scss";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
export const CertificateController = (props) => {
	const [results, setResults] = useState([]);
	const [onTab, setOnTab] = useState(2);
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/profile?param=certificate&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, []);
	return (
		<>
			<Helmet>
				<title>Certificates | SmarterChains</title>
				<meta name="description" content="Certificates" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/profile">Account Settings</BreadcrumbsItem>
			<ProfileView onTab={onTab} profileData={results} {...props} />
		</>
	);
};
